<div class="footer"
     fxLayout="row" fxLayoutAlign="space-between center"
     fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="space-evenly center">
    <img src="../../../assets/logo_footer.png" class="footer-logo start" [alt]="'logo'|i18n">
    <div *ngIf="version" class="footer-version">{{ 'CER Promoter V.{0}'|i18n:version }}</div>
    <div class="footer-text">{{ copyright }}</div>
    <div *ngIf="address" class="new-line footer-text">{{ address }}</div>
    <a [href]=cookiePolicyLink target="_blank" rel="noopener noreferrer" class="end">Cookie Policy</a>
</div>
